// Every route serves the same index.html, so the canonical and the description
// in that file described the home page on all six pages. That tells a search
// engine the other five are duplicates of the home page and should not be
// indexed separately, which would quietly undo the sitemap.
//
// This sets them per page instead. Call it once from each route.

const SITE = 'https://www.thegirlandherpiano.com'

const setTag = (selector, make, value, attr = 'content') => {
  let el = document.head.querySelector(selector)
  if (!el) {
    el = make()
    document.head.appendChild(el)
  }
  el.setAttribute(attr, value)
}

export const setPageMeta = ({ title, path, description }) => {
  if (title) document.title = title

  const url = SITE + (path || '/')

  setTag('link[rel="canonical"]', () => {
    const l = document.createElement('link')
    l.setAttribute('rel', 'canonical')
    return l
  }, url, 'href')

  setTag('meta[property="og:url"]', () => {
    const m = document.createElement('meta')
    m.setAttribute('property', 'og:url')
    return m
  }, url)

  if (title) {
    setTag('meta[property="og:title"]', () => {
      const m = document.createElement('meta')
      m.setAttribute('property', 'og:title')
      return m
    }, title)
  }

  if (description) {
    setTag('meta[name="description"]', () => {
      const m = document.createElement('meta')
      m.setAttribute('name', 'description')
      return m
    }, description)
    setTag('meta[property="og:description"]', () => {
      const m = document.createElement('meta')
      m.setAttribute('property', 'og:description')
      return m
    }, description)
  }
}

export default setPageMeta
